//styles
import '../styles/title.css'
const Title = ({children}) => {
  return (
    <div className='title'>{children}</div>
  )
}

export default Title